// extracted by css-extract-rspack-plugin
export default {"cls1":"AdminBarActivator-cls1_kgA","cls2":"AdminBarActivator-cls2_y2w AdminBarActivator-cls1_kgA"};